import { useContext } from "react";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { SurveyContext } from "../../store/survey-context";
import "./footer.scss";
import CtaBackDashboard from "../../components/ctaBackDashboard/ctaBackDashboard";

export default function Footer(props) {
  const context = useContext(SurveyContext);
  const { t, ready } = useTranslation("common", { useSuspense: false });

  if (!ready) return null;

  function onOpenCookieWidget() {
    if (typeof Syrenis_OpenCookieOptionsModal === "function")
      window.Syrenis_OpenCookieOptionsModal();
  }

  const lang = i18n.language.toLowerCase();

  return (
    <>
      <footer>
        {(!context.showSurvey || context.error !== false) && (
          <CtaBackDashboard
            onClick={() => context.setDialogOpen(true)}
            showOnLargeScreen={false}
          />
        )}
        <div className="footer__bottom">
          <div className="footer__item-1">
            <nav
              role="navigation"
              aria-label={t("footer.menu_a11y")}
              // aria-labelledby="block-themacallan-v2-footer-menu"
              id="block-themacallan-v2-footer"
              data-block-plugin-id="system_menu_block:footer"
            >
              <ul className="inline-menu">
                <li className="inline-menu__item">
                  <a
                    className="inline-menu__link"
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.drinkaware.co.uk/"
                  >
                    {t("footer.drink_responsibly")}
                  </a>
                </li>
                <li className="inline-menu__item">
                  <a
                    className="inline-menu__link"
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.edrington.com/"
                  >
                    {t("footer.edrington_group")}
                  </a>
                </li>
                <li className="inline-menu__item">
                  <a
                    className="inline-menu__link"
                    target="_blank"
                    rel="noreferrer"
                    href={`https://www.themacallan.com/${lang}/privacy-policy`}
                  >
                    {t("footer.privacy_policy")}
                  </a>
                </li>
                <li className="inline-menu__item">
                  <a
                    className="inline-menu__link"
                    target="_blank"
                    rel="noreferrer"
                    href={`https://www.themacallan.com/${lang}/cookies-policy`}
                  >
                    {t("footer.cookies_policy")}
                  </a>
                </li>
                <li className="inline-menu__item">
                  <a
                    className="inline-menu__link"
                    href="#cookie-widget"
                    onClick={(e) => {
                      e.preventDefault();
                      onOpenCookieWidget();
                    }}
                  >
                    {t("footer.cookie_preferences")}
                  </a>
                </li>
                <li className="inline-menu__item">
                  <a
                    className="inline-menu__link"
                    target="_blank"
                    rel="noreferrer"
                    href={`https://www.themacallan.com/${lang}/terms-of-use`}
                  >
                    {t("footer.terms_of_use")}
                  </a>
                </li>
                <li className="inline-menu__item">
                  <a
                    className="inline-menu__link"
                    target="_blank"
                    rel="noreferrer"
                    href={`https://www.themacallan.com/${lang}/contact-us`}
                  >
                    {t("footer.contact_us")}
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <div className="footer__item-2">
            <div className="block block-themacallan-v2-digitalplatformcopyright">
              <p>{t("footer.copyright", { year: new Date().getFullYear() })}</p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
